module.exports = __webpack_public_path__ + "static/media/15.81bd9857.jpeg";